module.exports = __webpack_public_path__ + "img/close.593bb8b3.svg";